const state = {
    error: '',
}

const getters = {
    error: state => state.error,
}

const mutations = {
    SET_ERROR(state, error) {
        state.error = error;
    }
}

const actions = {
    setError({ commit }, error) {
        commit('SET_ERROR', error);
    },
    clearError({ commit }) {
        commit('SET_ERROR', '');
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
